class CartDrawer extends HTMLElement {
  constructor () {
    super()

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
    this.setHeaderCartIconAccessibility()

    window.BAO.eventBus.addEventListener(window.BAO.EVENTS.PUSH_CART.LOG_IN, () => {
      this.close()
    })

    // Update cart if back button clicked
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) this.renderContents()
    })

    if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
      this.renderContents()
    }
  }

  setHeaderCartIconAccessibility () {
    const cartLink = document.querySelector('#cart-icon-bubble')
    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', (event) => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  open (triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote)
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') })

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer')
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')
      // eslint-disable-next-line no-undef
      trapFocus(containerToTrapFocusOn, focusElement)
    }, { once: true })

    document.body.classList.add('overflow-hidden')
  }

  close () {
    this.classList.remove('active')
    // eslint-disable-next-line no-undef
    removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')
  }

  setSummaryAccessibility (cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button')
    cartDrawerNote.setAttribute('aria-expanded', 'false')

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id)
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
    })

    // eslint-disable-next-line no-undef
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape)
  }

  async renderContents (parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty')
    if (parsedState) {
      this.productId = parsedState.id
    }

    if (!parsedState || !parsedState.sections) {
      // eslint-disable-next-line no-undef
      const sections = await fetch(`${routes.cart_url}?sections=${this.getSectionsToRender().map(section => section.id)}`)
      parsedState.sections = await sections.json()
    }

    this.getSectionsToRender().forEach(section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id)
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
    })

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
      this.open()
    })
  }

  getSectionInnerHTML (html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  getSectionsToRender () {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ]
  }

  getSectionDOM (html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
  }

  setActiveElement (element) {
    this.activeElement = element
  }
}

customElements.define('cart-drawer', CartDrawer)

// eslint-disable-next-line no-undef
class CartDrawerItems extends CartItems {
  getSectionsToRender () {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]
  }
}

customElements.define('cart-drawer-items', CartDrawerItems)
